export const SNAPSHOT = process.env.NODE_ENV === "production" && navigator.userAgent === "ReactSnap"